module.exports = __webpack_public_path__ + "static/media/profile.e1998339.svg";